<template>
  <div class="d-flex flex-column align-items-center">
    <content-body-card class="w-100 p-0">
      <el-row class="mb-20">
        <el-col :span="24">
          <!-- el selection to select member -->
          <div class="mb-10">
            <el-select v-model="selectedMember">
              <el-option v-for="member in members" :key="member._id"  :label="`${member.profile.firstName} ${member.profile.lastName}`" :value="member._id">
                {{ member.profile.firstName }} {{ member.profile.lastName }}
              </el-option>
            </el-select>
          </div>
          <el-table
            :data="filteredRegistrations"

            style="width: 100%"
            stripe
            :row-class-name="getClassnameById"
            class="item-table hidden-sm-and-down"
          >
            <el-table-column type="expand" label=" " width=50>
              <template slot-scope="scope">
                <div v-if="scope.row.productType !== 'legacy-membership'">
                  Product Type: {{scope.row.productType === 'indv' ? 'Individual'
                                  :scope.row.productType === 'indv-to-team' ? 'Individual To Team'
                                  :scope.row.productType === 'team' ? 'Team'
                                  : ''
                                  }}
                </div>
                <div v-if="scope.row.tags && scope.row.tags.length > 0">Tags: {{ joinTag(scope.row.tags) }}</div>
                <div>Status: {{ scope.row.expired ? 'Inactive': 'Active'}}</div>
                <div class="mb-10">
                  <span>Result: </span>
                  <div class="result-capture" v-if="Object.keys(scope.row.results).length" >
                    <div>{{ scope.row.results.name }}</div>
                    <div class="font-light">{{ scope.row.results.value }} ({{ getResultLabel(scope.row.results.type) }})</div>
                  </div>
                  <span v-else>Not Released Yet </span>
                </div>
                <div>
                  <div>Files Uploaded: </div>
                  <div v-for="([group, files]) in groupedUploads(scope.row.files)" :key="group">
                    <h5 class="mt-0 mb-0">{{ group }}</h5>
                    <el-upload
                      :auto-upload="false"
                      :ref="`uploadDesktop-${scope.row._id}-${group}`"
                      :file-list="files ? files.map(file => ({_id: file._id, name: `${file.originalName || file.fileName} Uploaded At: ${dateFormatter(file.createdAt)}`, url: file.path, registrationId: file.meta.registrationId, type: file.fileType})) : []"
                      :on-preview="previewUpload"
                      :on-change="(file, fileList) => handleChange(file, fileList, {
                        _id: files._id,
                        registrationId: scope.row._id,
                        additionalQuestion: group,
                        entityId: scope.row.entityId,
                        entityType: scope.row.entityType,
                        memberId: value._id,
                        type: 'additional-question',
                      })"
                      :on-error="onError"
                      :before-upload="beforeUpload"
                      :before-remove="removeFile"
                      action=""
                      :headers="uploadHeaders"
                      :accept="accept"
                      :disabled="getUploadExpiry(scope.row)"

                      >
                      <el-button
                      slot="trigger"
                      size="small"
                      type="primary"
                      v-if= "isNotExpired(scope.row)"
                      >
                        Add File(s)
                      </el-button>
                      <!-- <div class="el-upload__tip" slot="tip">{{ getUploadTip(scope.row, group) }}</div> -->
                    </el-upload>
                  </div>
                </div>
                <div v-if="nationalId === 4 && scope.row.productType == 'indv-to-team'">
                  <fieldset class="mt-10" v-if="scope.row.team.meta && scope.row.team.meta.captain" style="width: 450px">
                    <legend>Captain</legend>
                    <p>Captain: {{ scope.row.team.meta.captain.name || '-' }}</p>
                    <p>Email: {{ scope.row.team.meta.captain.email || '-' }}</p>
                    <p>Mobile: {{ scope.row.team.meta.captain.mobile || '-' }}</p>
                  </fieldset>
                  <fieldset class="mt-10" v-if="scope.row.team.meta && scope.row.team.meta.viceCaptain" style="width: 450px">
                    <legend>Vice Captain</legend>
                    <p>Vice Captain: {{ scope.row.team.meta.viceCaptain.name || '-' }}</p>
                    <p>Email: {{ scope.row.team.meta.viceCaptain.email || '-' }}</p>
                    <p>Mobile: {{ scope.row.team.meta.viceCaptain.mobile || '-' }}</p>
                  </fieldset>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Entity"
              min-width="250"
            >
                <template slot-scope="scope">
                <div class="break-word" >{{entityFormatter(scope.row)}}</div>
                <el-button size="small" v-if="isUpgradeEligible(scope.row)" type="primary" @click="handleDropdown(scope.row,'open')" :key="key">
                  Upgrade Membership
                </el-button>
                <el-button class="mb-05" size="small" v-if="scope.row.entityType === 'membership' && get(scope, 'row.regoEntity.products.isUpgradeable') && scope.row.upgradingDropdown" type="danger" @click="handleDropdown(scope.row, 'close')" :key="key">
                  Cancel
                </el-button>
                <el-cascader
                v-if="scope.row.entityType === 'membership' && get(scope, 'row.regoEntity.products.isUpgradeable') && scope.row.upgradingDropdown"
                v-model="scope.row.regoEntity.membershipToUpgrade"
                :options="getFilterdMemberships(get(scope, 'row.regoEntity.products.upgradeableMembershipList'))"
                :props="{label: 'name', value: '_id', children: 'products' }"
                clearable
                filterable
                size="medium"
                :show-all-levels="true"
                separator=" -> "
                @change="handleChangeMem(scope.row)">
              </el-cascader>
              </template>
            </el-table-column>
            <el-table-column prop="teamCode" label=""  width="130">
              <template slot="header">
                Team Code
                <el-tooltip class="item" effect="dark"  placement="top">
                  <div slot="content">
                    Team Code is a unique identifier for the team. It is used to identify the team in the portal.
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div v-if="get(scope.row, 'team.teamCode')">
                  {{ get(scope.row, 'team.teamCode', '-') }}
                </div>
                <div v-else>
                  <el-button size="medium" type="text" @click="generateTeamCode(scope.row)" :key="key">
                    Generate
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="Registration Date"
              width="190"
              sortable
            >
              <template slot-scope="scope">
                  {{ scope.row.createdAt | formatDate }}
              </template>
            </el-table-column>
            <!-- column for paid status -->
            <el-table-column
              prop="paid"
              label="Paid"
              width="150"
              sortable
            >
              <template slot-scope="scope">
               <!-- in format of paid/total -->
               <div>
                {{ getPaidStatus(scope.row) }}
               </div>
              </template>
            </el-table-column>
            <!-- registered by -->
            <el-table-column
              label="Registered By"
              width="150"
              sortable
            >
              <template slot-scope="scope">
                {{ get(scope.row, 'member.profile.firstName') }} {{ get(scope.row, 'member.profile.lastName') }}
              </template>
            </el-table-column>
            <el-table-column
              prop="entityType"
              label="Entity Type"
              :formatter="(r,c,v)=>capitalize(v)"
              width="150"
              sortable
            >
            </el-table-column>
            <el-table-column prop="season" label="Season" width="120">
            </el-table-column>
            <el-table-column label="Operations" fixed="right" width="240">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <span>Download Receipt</span>
                  </div>
                  <span>
                    <el-button size="mini" type="danger" @click="downloadReceipt(scope.row)">
                      <i class="el-icon-download"></i>
                    </el-button>
                  </span>
                </el-tooltip>
                <!-- button to pay -->
                <el-button class="ml-05" size="mini" type="primary" :disabled="isPaid(scope.row)" @click="triggerPaymentDialog(scope.row)">
                  {{ getPayButtonText(scope.row) }}
                </el-button>
                <el-button class="ml-05" size="mini" type="primary" @click="downloadMemberList(scope.row)">
                  <i class="el-icon-download"></i> Members
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-table
            :data="registrations"
            border
            stripe
            class="item-table hidden-md-and-up"
          >
            <el-table-column type="expand" label=" " width=50>
              <template slot-scope="scope">
                <p>Status: {{ scope.row.expired ? 'Inactive': 'Active'}}</p>
                <div class="mb-10">
                  <span>Result: </span>
                  <div class="result-capture" v-if="Object.keys(scope.row.results).length" >
                    <div>{{ scope.row.results.name }}</div>
                    <div class="font-light">{{ scope.row.results.value }} ({{ getResultLabel(scope.row.results.type) }})</div>
                  </div>
                  <span v-else>Not Released Yet </span>
                </div>
                <div>
                  <div>Files Uploaded: </div>
                  <div v-for="([group, files]) in groupedUploads(scope.row.files)" :key="group">
                <h5>{{ group }}</h5>
                <el-upload
                  :ref="`uploadMobile-${scope.row._id}-${group}`"
                  :file-list="files ? files.map(file => ({_id: file._id, name: file.fileName, url: file.path, registrationId: file.meta.registrationId, type: file.fileType})) : []"
                  :on-preview="previewUpload"
                  :on-change="(file, fileList) => handleChange(file, fileList, {
                    _id: files._id,
                    registrationId: scope.row._id,
                    additionalQuestion: group,
                    entityId: scope.row.entityId,
                    entityType: scope.row.entityType,
                    memberId: value._id,
                    type: 'additional-question',
                  })"
                  :on-error="onError"
                  :before-remove="removeFile"
                  action=""
                  :headers="uploadHeaders"
                  :accept="accept"
                  :auto-upload="false"
                  :disabled="getUploadExpiry(scope.row)"
                  >
                  <el-button
                  slot="trigger"
                  size="small"
                  type="primary"
                  v-if="isNotExpired(scope.row)"
                  >
                    Add File(s)
                  </el-button>
                  <!-- <div class="el-upload__tip" slot="tip">{{ getUploadTip(scope.row, group) }}</div> -->
                </el-upload>
              </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Entity"
              min-width="250"
            >
            <template slot-scope="scope">
                <div class="break-word" >{{entityFormatter(scope.row)}}</div>
                <el-button size="small" v-if="isUpgradeEligible(scope.row)" type="primary" @click="handleDropdown(scope.row,'open')" :key="key">
                  Upgrade Membership
                </el-button>
                <div>
                  <el-button size="small" class="mb-05 mr-05" v-if="scope.row.entityType === 'membership' && get(scope, 'row.regoEntity.products.isUpgradeable') && scope.row.upgradingDropdown" type="danger" @click="handleDropdown(scope.row,'close')" :key="key">
                    Cancel
                  </el-button>
                </div>
                <el-cascader
                  v-if="scope.row.entityType === 'membership' && get(scope, 'row.regoEntity.products.isUpgradeable') && scope.row.upgradingDropdown"
                v-model="scope.row.regoEntity.membershipToUpgrade"
                :options="getFilterdMemberships(get(scope, 'row.regoEntity.products.upgradeableMembershipList'))"
                :props="{ label: 'name', value: '_id', children: 'products' }"
                clearable
                filterable
                size="small"
                :show-all-levels="false"
                separator=" -> "
                @change="handleChangeMem(scope.row)">
              </el-cascader>
              </template>
            </el-table-column>
            <el-table-column prop="teamCode" label=""  width="130">
              <template slot="header">
                Team Code
                <el-tooltip class="item" effect="dark"  placement="top">
                  <div slot="content">
                    Team Code is a unique identifier for the team. It is used to identify the team in the portal.
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div v-if="get(scope.row, 'team.teamCode')">
                  {{ get(scope.row, 'team.teamCode', '-') }}
                </div>
                <div v-else>
                  <el-button size="medium" type="text" @click="generateTeamCode(scope.row)" :key="key">
                    Generate
                  </el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="memberType"
              label="Member Type"
              :formatter="(r,c,v)=>capitalize(v)"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="Registration Date"
              width="190"
              sortable
            >
              <template slot-scope="scope">
                  {{ scope.row.createdAt | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
              prop="entityType"
              label="Entity Type"
              :formatter="(r,c,v)=>capitalize(v)"
              width="150"
              sortable
            >
            </el-table-column>
            <el-table-column label="Operations"  width="240">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <span>Download Receipt</span>
                  </div>
                  <span>
                    <el-button size="mini" type="danger" @click="downloadReceipt(scope.row)">
                      <i class="el-icon-download"></i>
                    </el-button>
                  </span>
                </el-tooltip>
                <!-- button to pay -->
                <el-button class="ml-05" size="mini" type="primary" :disabled="isPaid(scope.row)" @click="triggerPaymentDialog(scope.row)">
                  {{ getPayButtonText(scope.row) }}
                </el-button>
                <el-button class="ml-05" size="mini" type="primary" @click="downloadMemberList(scope.row)">
                  <i class="el-icon-download"></i> Members
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </content-body-card>

    <el-dialog v-if="registration" :show-close="true" :visible="paymentDialog" @close="paymentDialog = false" width="80%" :title="`Payment for ${registration.event[0].name}`">
    <el-row :gutter="20">
      <el-form ref="form" :model="payment" :rules="rules" class="payment-form">
      <el-col :span="12" class="payment-section">
        <h2>Payment Details</h2>
        <el-price-input v-model="payToday" :min="minPayment" :max="outstanding" :key="key" :disabled="registration.payLater" />
        <div class="pay-today">
          Pay Today: <strong>{{ parsePrice(payTodayTotal) }}</strong>
          <!-- <span class="transaction-fee">*Includes a 4% transaction fee</span> -->
        </div>
        <div class="transaction-fee">*Includes a {{ transactionFee }}% transaction fee</div>
        <div class="credit-card-section">
          <h2>Credit Card Details</h2>
          <credit-card v-model="payment.card" ref="card" :width="300"/>
        </div>
      </el-col>
      <el-col :span="12" class="billing-section">
        <h2>Billing Address</h2>
        <el-form-item label="Address Line 1">
                  <el-input v-model="payment.billingAddress.addressLine1" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="Address Line 2">
                  <el-input v-model="payment.billingAddress.addressLine2" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="City/Suburb">
                  <el-input v-model="payment.billingAddress.suburb" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="State">
                  <el-input v-model="payment.billingAddress.state" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="Postcode">
                  <el-input v-model="payment.billingAddress.postcode" placeholder="Type here..." />
                </el-form-item>
                <el-form-item class="d-flex flex-column align-items-start" label="Country">
                  <el-select filterable remote reserve-keyword v-model="payment.billingAddress.country" :remote-method="searchCountry" placeholder="Select">
                    <el-option v-for="item in countryItems" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
      </el-col>
      </el-form>
    </el-row>
    <div>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="24">
          <!-- 2 buttons, one for cancel, one for make payment -->
          <div class="make-payment-btn">
            <el-button type="secondary" @click="paymentDialog = false">Cancel</el-button>
            <el-button type="primary" @click="submitPayment">Make Payment</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { calculateMemberAge } from '@/utils/helpers';
import { mapGetters } from 'vuex';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { clientNationalIds } from '@/utils/client-rules';
import {
  errormsg, countries, fileUploadAcceptString, resultTypes
} from '@/utils/constants';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.input_option };
const pin = new Pin.Api(process.env.VUE_APP_PIN_PK, process.env.VUE_APP_PIN_ENV);

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      subTitle:
        'On this screen you can view current team information and registration history.',
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      key: 0,
      capitalize: _.capitalize,
      registrations: [],
      membershipToRegister: {},
      fileUploadAcceptString,
      get: _.get,
      members: [],
      selectedMember: undefined,
      pin,
      payment: {
        card: {},
        billingAddress: {}
      },
      registration: undefined,
      rules: {
        'billingAddress.addressLine1': defaultRequiredRule,
        'billingAddress.suburb': defaultRequiredRule,
        'billingAddress.state': +process.env.VUE_APP_NATIONAL_ID === 17 ? { required: false } : defaultRequiredRule,
        'billingAddress.postcode': defaultRequiredRule,
        'billingAddress.country': defaultRequiredRule,
      },
      payToday: 0,
      countryItems: [],
      countries,
      paymentDialog: false,
    };
  },
  mounted() {
    const { regoId, regoProductId } = this.$route.params;
    if (this.userId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.get(`/assemble/api/v1/portal/team-registrations/members/${this.userId}`).then((resTeam) => {
        const teamRegistrations = _.map(resTeam.data.data, (data) => ({ ...data, results: _.get(data, 'results.0', {}) }));
        this.registrations = teamRegistrations.map((rego) => _.assign(rego, { upgradingDropdown: false }));
        // get all members from registrations
        const teamRegosHasMembers = _.filter(this.registrations, (rego) => rego.member);
        this.members = teamRegosHasMembers.map((rego) => rego.member);
        // add option all members
        this.members.unshift({ _id: undefined, profile: { firstName: 'All', lastName: 'Members' } });
        // eslint-disable-next-line no-restricted-syntax
        for (const membership of this.registrations) {
          if (membership.regoEntity && membership.regoEntity.products && membership.regoEntity.products.upgradeableMembershipList && membership.expired !== true) {
            // eslint-disable-next-line no-restricted-syntax
            for (const um of membership.regoEntity.products.upgradeableMembershipList) {
              if (um._id === regoId) {
                const foundProduct = um.products.find((product) => product._id === regoProductId);
                if (foundProduct) {
                  setTimeout(() => {
                    // eslint-disable-next-line prefer-destructuring
                    const position = (document.getElementsByClassName(`${membership._id}`))[0];
                    position.scrollIntoView({ behavior: 'smooth' });
                  }, 200);
                }
              }
            }
          }
        }

        this.$store.commit('loading', false);
      })
        .catch((e) => {
          this.$message.error(e);
          this.$store.commit('loading', false);
        });
    }
  },
  methods: {
    getBase64Logo(logoUrl) {
      const logo = logoUrl || this.logo;
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ logo }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
    async downloadMemberList(row) {
      if (pdfMake.vfs === undefined) pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // add filter params
      const eventId = row.regoEntity._id;
      const homeDD = await this.$http.get(`/assemble/api/v1/portal/teams/${row.team._id}/member-list-pdf`, { params: { event: eventId } });
      console.log(homeDD.data.data, 'homeDD');
      const logoUrl = homeDD.data.entityImgUrl;
      console.log(logoUrl, 'logoUrl');

      homeDD.data.data.content.unshift('\n');
      homeDD.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
      console.log(await this.getBase64Logo(logoUrl), 'logo');
      homeDD.data.data.images = { logo: await this.getBase64Logo(logoUrl) };
      console.log(homeDD.data.data, 'homeDD');
      return pdfMake.createPdf(homeDD.data.data).download(`${row.team._id}-member-list.pdf`);
    },
    searchCountry(query) {
      if (query !== '') {
        setTimeout(() => {
          this.countryItems = this.countries.filter(
            (item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        }, 200);
      } else {
        this.countryItems = [];
      }
    },
    triggerPaymentDialog(registration) {
      console.log(registration, 'registration');
      this.$set(this, 'registration', registration);
      const registrationOutstanding = registration.pricing.event.total - this.getAmountPaid(registration);
      this.payToday = registrationOutstanding;
      this.paymentDialog = true;
      this.key++;
    },
    getAmountPaid(registration) {
      return registration.payments ? registration.payments.reduce((acc, current) => (current.amount ? acc + current.amount - current.transactionFee : acc), 0) : 0;
    },
    submitPayment() {
      Promise.all([this.$refs.card && this.$refs.card.validate(), this.$refs.form && this.$refs.form.validate()])
        .then(([cardValid, formValid]) => {
          if (this.requirePayment && (!cardValid || !formValid)) return;

          // issue card token
          const [expiryMonth, expiryYear] = this.payment.card.expiry.replace(/\s/g, '').split('/');

          this.$store.commit('loading', true);
          this.pin.createCardToken({
            number: this.payment.card.number,
            name: this.payment.card.name,
            expiry_month: expiryMonth,
            expiry_year: expiryYear,
            cvc: this.payment.card.cvc,
            address_line1: this.payment.billingAddress.addressLine1,
            address_line2: this.payment.billingAddress.addressLine2 || '',
            address_city: this.payment.billingAddress.suburb,
            address_state: this.payment.billingAddress.state,
            address_postcode: this.payment.billingAddress.postcode,
            address_country: 'Australia',
          }).then((pinResponse) => {
            // Block International Cards
            // eslint-disable-next-line camelcase, no-unused-vars
            const { token, issuing_country, scheme } = pinResponse;
            // || !_.includes(['master', 'visa'], scheme)
            // eslint-disable-next-line camelcase
            if (!['AU', 'NZ'].includes(issuing_country) && [14, 18].includes(+process.env.VUE_APP_NATIONAL_ID)) {
              this.$store.commit('loading', false);
              this.$message.error('International cards are not supported.');
              return false;
            }

            if (!token) {
              this.$store.commit('loading', false);
              this.$message.error('There has been an error, try again later.');
            }
            // register with card token
            this.pay(token);
          }).catch((err) => {
            this.$store.commit('loading', false);
            const pinError = _.get(err, 'error_description');
            this.$message.error(pinError || 'There has been an error');
          });
        }).catch(() => {});
    },
    pay(token) {
      if (!token) return false;
      this.$store.commit('loading', true);
      return this.$http.post('/assemble/api/v1/portal/payments/outstanding/team', {
        cardToken: token,
        paymentTotal: this.payTodayTotal,
        paymentInstallment: this.payToday,
        eventId: this.registration.entityId,
        teamId: this.registration.team._id,
      }).then((res) => {
        this.$message.success('Payment Successful');
        this.paymentDialog = false;
        // assign the res.data.data to the correct index in registrations
        const [rego] = res.data.data;
        const { payments } = rego;
        const index = this.registrations.findIndex((reg) => reg._id === this.registration._id);
        console.log(index, 'index');
        this.registration.payments = payments;
        this.$set(this.registrations, index, this.registration);
        this.$forceUpdate();
        this.registration = undefined;
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
      });
    },
    getPaidStatus(rego) {
      const { payments, pricing, charge } = rego;
      if (rego.payAfter) {
        // total paid is amount - fee for each payment
        const totalPaid = _.sumBy(payments, (p) => p.amount - p.transactionFee);
        const total = _.get(pricing, 'event.total', 0);
        return total > 0 ? `$${(totalPaid / 100).toFixed(2)} / $${(total / 100).toFixed(2)}` : '$0';
      }
      // total paid is amount - fee for each charge
      const totalPaid = _.sumBy(charge, (c) => c.amount - c.meta.transactionFee);
      const total = _.get(pricing, 'event.total', 0);
      return total > 0 ? `$${(totalPaid / 100).toFixed(2)} / $${(total / 100).toFixed(2)}` : '$0';
    },
    isPaid(rego) {
      const { payments, pricing, charge } = rego;
      if (rego.payAfter) {
        // total paid is amount - fee for each payment
        const totalPaid = _.sumBy(payments, (p) => p.amount - p.transactionFee);
        const total = _.get(pricing, 'event.total', 0);
        if (totalPaid === total) {
          return true;
        }
        return false;
      }
      // total paid is amount - fee for each charge
      const totalPaid = _.sumBy(charge, (c) => c.amount - c.meta.transactionFee);
      const total = _.get(pricing, 'event.total', 0);
      if (totalPaid === total) {
        return true;
      }
      return false;
    },
    getPayButtonText(rego) {
      if (this.isPaid(rego)) {
        return 'Paid';
      }
      return 'Pay';
    },
    isUpgradeEligible(rego) {
      if (rego.entityType === 'membership' && _.get(rego, 'regoEntity.products.isUpgradeable') && !rego.upgradingDropdown && !rego.expired) {
        const { dob, gender } = this.value.profile;
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(dob, endOfYear);
        const membershipList = _.get(rego, 'regoEntity.products.upgradeableMembershipList', []);
        const checkEligible = membershipList.some((membership) => _.get(membership, 'products', []).some((product) => age >= product.ageFrom && age <= product.ageTo && (product.gender === gender || product.gender === 'All' || (product.gender === 'Other' && (gender !== 'Male' || gender !== 'Female')))));
        return checkEligible;
      }
      return false;
    },
    getFilterdMemberships(upgradeableMembershipList) {
      const { dob, gender } = this.value.profile;
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      const list = _.cloneDeep(upgradeableMembershipList);
      list.forEach((membership) => {
        // eslint-disable-next-line no-param-reassign
        membership.products = membership.products.filter((product) => age >= product.ageFrom && age <= product.ageTo && (product.gender === gender || product.gender === 'All' || (product.gender === 'Other' && (gender !== 'Male' || gender !== 'Female'))));
      });
      return list;
    },
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    async downloadReceipt(registration) {
      const parsePrice = (val) => (val / 100).toFixed(2);
      let charges = [];
      try {
        const response = await this.$http.get(`/assemble/api/v1/portal/team-registrations/${registration._id}/receipt`);
        charges = response.data.data;
      } catch {
        this.$message.error('An error occured while downloading receipt');
      }

      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      if (!charges.length) this.$message.success('This registration did not incur any cost thus no receipt was found');

      charges.forEach((charge) => {
        const {
          _id: chargeId, registrations, amount, meta, createdAt
        } = charge;

        const { regoEntity } = registrations[0];
        const product = regoEntity.products;

        const totalRegistrationFee = _.sumBy(registrations, (r) => _.get(r, `pricing.${r.entityType}.price`, 0));
        const totalSaleableItems = _.sumBy(registrations, (r) => _.get(r, `pricing.${r.entityType}.totalSaleableItems`, 0));
        const discount = _.sumBy(registrations,
          (r) => _.get(r, `pricing.${r.entityType}.discounts[0].redeemedAmount`, 0)
            + _.get(r, 'pricing.activeKidsVoucher.redeemedAmount', 0));

        const bodySummary = [
          [
            { text: 'Registration Fee', style: 'bold' },
            { text: `$${parsePrice(totalRegistrationFee)}`, style: ['alignRight', 'bold'] },
          ],
          [
            { text: 'Saleable Items', style: 'bold' },
            { text: `$${parsePrice(totalSaleableItems)}`, style: ['alignRight', 'bold'] },
          ],
          [
            { text: 'Discounts', style: 'bold' },
            { text: `-$${parsePrice(discount)}`, style: ['alignRight', 'bold'] },
          ],
          [
            { text: 'Transaction Fee', style: 'bold' },
            { text: `$${parsePrice(meta.transactionFee || 0)}`, style: ['alignRight', 'bold'] },
          ],
          [
            { text: 'GST Incl.', style: 'bold' },
            { text: `$${parsePrice(amount / 11)}`, style: ['alignRight', 'bold'] },
          ],
          [
            { text: 'Amount Paid', style: 'bold' },
            { text: `$${parsePrice(amount)}`, style: ['alignRight', 'bold'] },
          ]
        ];

        if (_.get(product, 'gstRegistered') === false) bodySummary.splice(4, 1);

        const dd = {
          content: [
            { image: 'logo', width: [100], alignment: 'center' },
            {
              text: `You have successfully made a payment of $${parsePrice(amount)} AUD.`,
              margin: [0, 25, 0, 0],
            },
            '\n',
            `Invoice ID: ${chargeId}`,
            moment(createdAt).format('DD/MM/YYYY'),
            '\n',
            {
              text: 'Payment breakdown:',
              style: {
                bold: true
              }
            },
            ...registrations.map((rego) => ([
              {
                text: _.get(rego, 'entity.name', ''), style: 'subheader'
              },
              {
                style: 'tableExample',
                table: {
                  widths: ['auto', '*'],
                  textAlign: 'center',
                  body: [
                    [
                      { text: 'Team ID', style: 'bold' },
                      { text: rego.teamId, style: ['alignLeft', 'bold'] },
                    ],
                    [
                      { text: 'Team Name', style: 'bold' },
                      { text: rego.team.name, style: ['alignLeft', 'bold'] },
                    ],
                    [
                      { text: 'Team Contact Name', style: 'bold' },
                      { text: rego.team.contact.name, style: ['alignLeft', 'bold'] },
                    ],
                    [
                      { text: 'Team Contact Mobile', style: 'bold' },
                      { text: rego.team.contact.number, style: ['alignLeft', 'bold'] },
                    ],
                    [
                      { text: 'Team Contact Email', style: 'bold' },
                      { text: rego.team.contact.email, link: rego.team.contact.email, style: ['alignLeft', 'bold'] },
                    ],
                    [
                      { text: 'Team Registration Link', style: 'bold' },
                      {
                        text: `${window.location.origin}/finder?id=${rego.teamId}`,
                        link: `${window.location.origin}/finder?id=${rego.teamId}`,
                        style: ['alignLeft', 'bold']
                      },
                    ]
                  ],
                },
                layout: {
                  hLineColor: 'lightgray',
                  vLineColor: 'lightgray',
                }
              },
              {
                style: 'tableExample',
                table: {
                  widths: ['auto', '*', '*'],
                  textAlign: 'center',
                  body: [
                    [
                      { text: 'Product', style: 'tableHeader' },
                      { text: 'Qty', style: ['tableHeader', 'alignRight'] },
                      { text: 'Cost', style: ['tableHeader', 'alignRight'] },
                    ],
                    [
                      { text: rego.productName || 'Registration Fee' },
                      { text: '1', style: 'alignRight' },
                      { text: `$${parsePrice(rego.pricing[rego.entityType].price)}`, style: 'alignRight' },
                    ],
                    ...rego.pricing[rego.entityType].saleableItems.map((item) => ([
                      { text: item.name },
                      { text: item.qty, style: 'alignRight' },
                      { text: `$${parsePrice(item.price)}`, style: 'alignRight' },
                    ])),
                    ...rego.pricing[rego.entityType].discounts.map((d) => ([
                      { text: d.name },
                      '',
                      { text: `$${parsePrice(d.redeemedAmount)}`, style: 'alignRight' },
                    ])),
                    rego.pricing.activeKidsVoucher
                      ? ([
                        { text: 'Active Kids Voucher' },
                        { text: '' },
                        { text: `$${parsePrice(rego.pricing.activeKidsVoucher.redeemedAmount)}`, style: 'alignRight' },
                      ])
                      : ['', '', ''],
                  ]
                },
                layout: {
                  hLineColor: '#ffffff',
                  vLineColor: '#ffffff',
                }
              },
            ])),
            'Payment Summary:\n',
            {
              style: 'tableExample',
              table: {
                widths: ['auto', '*'],
                textAlign: 'center',
                body: bodySummary,
              },
              layout: {
                hLineColor: 'lightgray',
                vLineColor: 'lightgray'
              }
            },
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            subheader: {
              fontSize: 14,
              bold: true,
              color: '#111111',
              margin: [0, 10, 0, 5]
            },
            tableExample: {
              margin: [0, 20, 0, 20],
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black',
              fillColor: 'lightgray',
            },
            alignRight: {
              alignment: 'right',
            },
            bold: {
              bold: true,
              color: '#111111',
            }
          },
          images: {
            logo: 'https://ci5.googleusercontent.com/proxy/7YsaGfsvE53RYO5D7E6mrkw23GxF0bYQWWOX8ZjSkSLfQ_EJXahvpmrnvt0JA1dXrXGaJxZM-WPlQhsT42_H9y8jygEf4cftsL9mevX-c95MY9v078jnWEJsIwWq5k4NcpXFDxtXj06mhprh53k4pg=s0-d-e1-ft#https://assemble-sports-assets.s3-ap-southeast-2.amazonaws.com/Assemble+Logo_RGB_Positive.png'
          },
          defaultStyle: {
            fontSize: 14,
            // alignment: 'justify'
          }
        };
        pdfMake.createPdf(dd).download(`${this.userId}-${chargeId}.pdf`);
      });
    },

    getResultLabel: (type) => _.find(resultTypes, { type }).label,
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    onError(error) {
      if (error.message) {
        const json = JSON.parse(error.message);
        this.$message.error(json.message || 'There has been an error');
      } else {
        this.$message.error('There has been an error');
      }
    },
    entityFormatter(row) {
      if (!row.fromImport) {
        if (row.team && row.team.name) return `${row.team.name} - ${_.get(row, 'regoEntity.name')}`;
        return row.regoEntity.name || '';
      }

      return row.meta.productName || '';
    },
    generateTeamCode(registration) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post(`/assemble/api/v1/portal/team/${registration.team._id}/generate-team-code`)
        .then((res) => {
          const code = res.data.data;
          console.log('code', code);
          const index = this.registrations.findIndex((r) => r._id === registration._id);
          this.registrations[index].team.teamCode = code;
          this.$message.success('Team code generated successfully');
          this.$store.commit('loading', false);
          this.$forceUpdate();
        })
        .catch((e) => {
          this.$message.error(e);
          this.$store.commit('loading', false);
        });
    },
    dateFormatter(timestamp) {
      return this.moment(timestamp).format('DD/MM/YYYY HH:mm');
    },
    handleChangeMem(rego) {
      const registrations = this.$store.getters['cart/registrations'];
      const [id, productId] = _.get(rego, 'regoEntity.membershipToUpgrade');
      const memberId = this.value._id;
      this.$confirm('Are you sure you want to upgrade this membership?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then(() => {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post(`/assemble/api/v1/portal/registrations/search/entities/${id}/products/${productId}`)
            .then((res) => {
              const { result, transactionFee } = res.data.data;
              const [resutObject] = result;
              // eslint-disable-next-line no-param-reassign
              this.membershipToRegister = resutObject;
              const { _id: entityId, productType, memberType } = this.membershipToRegister;

              const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.memberType === memberType);
              if (foundRego) this.$message.error('Registration for this member has already been added to cart.');
              else {
                this.$store.commit('cart/setTransactionFee', transactionFee);
                // eslint-disable-next-line no-param-reassign
                delete rego.upgradingDropdown;
                this.$router.push({
                  name: 'membership-register-individual',
                  params: { memberId, selectedMembership: this.membershipToRegister, upgradeFromMembership: rego },
                });
              }
              this.$store.commit('loading', false);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        })
        .catch(() => {});
    },
    async handleChange(file, fileList, config) {
      const fileIndex = fileList.findIndex((fl) => fl.name === file.name);
      try {
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        const res = await this.$http.post('/assemble/api/v1/portal/files/presigned-url', { fileName: file.name });
        const { url, name } = res.data.data;
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });
        const nameOnly = name.split('.')[0];
        const fileTypeOnly = name.split('.')[name.split('.').length - 1];
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].name = nameOnly;
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].type = fileTypeOnly;
        this.$store.commit('loading', false);
      } catch (e) {
        this.$message.error('There has been an error');
      }
      this.$store.commit('loading', { loading: true, text: 'Loading...' });

      // After uploading via s3 presigned url, update file-uploads collection
      this.$http.post(this.fileUpdateUrl, {
        originalName: file.raw.name.split('.')[0],
        fileName: file.name,
        fileType: file.type,
        ...config
      }).then((res) => {
        const { fileId, fileName } = res.data.data;
        this.$message.success('File uploaded successfully');
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex]._id = fileId;
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].name = `${fileName} Uploaded At: ${this.dateFormatter(this.moment())}`;
      }).catch((e) => {
        console.log(e);
        this.$message.error('There has been an error uploading the file');
      }).finally(() => {
        this.$store.commit('loading', false);
      });
    },
    removeFile(file) {
      const fileId = file._id;
      if (fileId) {
        return this.$confirm('You are about to permanently delete this file. Are you sure you want to continue?', 'Warning', { type: 'warning' })
          .then(() => {
            this.$store.commit('loading', { loading: true, text: 'Loading...' });
            this.$http.delete(`/assemble/api/v1/portal/files/${fileId}`)
              .then(() => {
                this.$message.success('Success!');
                this.$store.commit('loading', false);
              })
              .catch(() => {
                this.$message.error('Error deleting file');
                this.$store.commit('loading', false);
              });
          })
          .catch();
      } if (file) {
        // Catch for when the file hasn't been uploaded yet
        return true;
      }
      return false;
    },
    getUploadExpiry(rego) {
      const { entityType } = rego;
      if (entityType === 'event') {
        const [event] = rego.event;
        const { regoEndDate, isActive } = event;
        if (moment().valueOf() <= regoEndDate && isActive) return false;
        return true;
      }
      return false;
    },
    getUploadTip(rego, field) {
      const question = rego.additionalQs.find((q) => q.fieldName === field);
      return question
        ? question.question
        : 'Uploaded files must be 10mb or less';
    },
    submitUpload(ref) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      const uploadComponent = this.$refs[ref][0];
      uploadComponent.submit();
    },
    previewUpload(file) {
      const { _id } = file;
      this.$http.get(`/assemble/api/v1/portal/files/${_id}/signed`)
        .then((res) => {
          window.open(res.data.url, '_blank');
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    groupedUploads(data) {
      const grouped = _.groupBy(data, (file) => file.meta.additionalQuestion);
      const out = Object.keys(grouped).map((group) => ([group, grouped[group]]));
      return out;
    },
    isNotExpired(rego) {
      if (+this.moment() <= rego.event[0].regoEndDate && rego.event[0].isActive) {
        return true;
      }
      return false;
    },
    handleDropdown(rego, val) {
      if (val === 'open') {
        // eslint-disable-next-line no-param-reassign
        rego.upgradingDropdown = true;
      } else {
        // eslint-disable-next-line no-param-reassign
        rego.upgradingDropdown = false;
      }
      this.key++;
    },
    getClassnameById({ row }) {
      return `${row._id}`;
    },
    joinTag(vals) {
      return vals ? _.join(_.map(vals, (v) => v.name), ', ') : '';
    },
  },
  computed: {
    logo() {
      const logo = process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '' ? process.env.VUE_APP_LOGO : 'https://assemble-sports-assets.s3-ap-southeast-2.amazonaws.com/Assemble+Logo_RGB_Positive.png';
      return logo;
    },
    transactionFee() {
      let defaultFee = +this.$store.getters['cart/transactionFee'];
      if (!defaultFee) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          defaultFee = +nationalMeta.transactionFee;
        }
      }
      const preferredFee = +this.$store.getters['national/paymentPreference'].addToTotal;
      console.log(preferredFee, 'preferredFee');
      return !(preferredFee >= 0) ? defaultFee : preferredFee;
    },
    filteredRegistrations() {
      return this.registrations.filter((rego) => (this.selectedMember ? rego.memberId === this.selectedMember : true));
    },
    customMemberDetailForm() {
      const nationalId = _.includes(clientNationalIds, +process.env.VUE_APP_NATIONAL_ID) ? process.env.VUE_APP_NATIONAL_ID : 0;
      // eslint-disable-next-line
      return () => import('@/views/app/clients/' + nationalId + '-member-profile-extras.vue');
    },
    accept() {
      return fileUploadAcceptString;
    },

    isNSWISA() {
      return +process.env.VUE_APP_NATIONAL_ID === 1;
    },
    memberIdLabel() {
      return +process.env.VUE_APP_NATIONAL_ID === 1 ? 'NSWISA Member ID' : 'Member ID';
    },
    fileUpdateUrl() {
      return `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/registration`;
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
    userId() {
      return this.$store.getters['user/userId'];
    },
    totalPrice() {
      const { registrations } = this;
      if (registrations && registrations.length > 0) {
        return registrations.reduce((acc, registration) => {
          const { pricing } = registration;
          const { total } = pricing.event;
          console.log(total, 'total');
          return acc + total;
        }, 0);
      }
      return 0;
    },
    amountPaidWithFee() {
      if (this.registration && this.registration.payments) {
        return _.sumBy(this.registration.payments, 'amount');
      }
      return 0;
    },
    amountPaid() {
      const { registration } = this;
      if (registration) {
        return this.getAmountPaid(registration);
      }
      return 0;
    },
    outstanding() {
      const { registration } = this;
      if (registration) {
        const { total } = registration.pricing.event;
        const amountPaid = this.getAmountPaid(registration);
        return total - amountPaid;
      }
      return 0;
    },
    minPayment() {
      const { outstanding } = this;
      return outstanding > 100 ? 100 : outstanding;
    },
    payTodayTotal() {
      const { payToday } = this;
      console.log(payToday, 'payToday');
      return +(payToday + ((payToday * this.transactionFee) / 100)).toFixed() || 0;
    }
  },
  filters: {
    cap(value) {
      return _.capitalize(value);
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__body{
  padding: 0;
}
::v-deep .el-card{
  border: none;
}

 ::v-deep .el-dialog{
      max-width: 70rem !important;
    }
    ::v-deep .el-dialog__body{
      display: inline-block;
    }
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding-top: 2em;
    text-align: left;
  }
}
  .payment-section, .billing-section {
    background-color: #fff;
    margin-bottom: 20px;
    h2 {
      color: #333;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .input-with-prefix {
      .el-input__inner {
        padding-left: 35px;
      }
      .dollar-sign {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #333;
        font-weight: bold;
      }
    }
    .pay-today {
      font-size: 16px;
      margin-top: 1rem;
      margin-bottom: 1rem;
      strong {
        color: #4CAF50;
        font-weight: bold;
      }
    }
    .transaction-fee {
      color: #999;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .credit-card-section {
      margin-top: 20px;
    }
  }
  .billing-section {
    h2 {
      margin-top: 0;
    }
  }
  .make-payment-btn {
    display: flex;
    justify-content: center;
  }

.price-divider {
  padding: 0 0.5rem;
}

</style>
